<template>
    <div class="global-quicksearch-result">
        <a :href="resultsPageUrl" v-if="resultsPageUrl">
            <h4 class="global-search-result__header"><span>{{ title }}</span> <span class="global-search-result__header-count">{{ $t('search.buttons.showCategoryWithCount', {count: result.count}) }} <global-icon icon="arrow-right" /></span></h4>
        </a>
        <ul class="global-search-result__body">
            <template v-for="resultItem in result.docs">
                <li><a :href="resultItem.href">{{ resultItem.title }}</a></li>
            </template>
        </ul>
        <hr>
    </div>
</template>

<script>
import GlobalIcon from "@global/global-elements/global-icon/global-icon";
export default {
    name: "global-quicksearch-result",
    components: {GlobalIcon},
    props: ['result', 'title', 'resultsPageUrl']
}
</script>
